import React, { useState, useEffect } from "react";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import StepOne from "components/user/stepOne/StepOne";
import StepTwo from "components/user/step-two/StepTwo";
import StepThree from "components/user/stepThree/StepThree";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserAuth from "components/AuthGaurd/UserAuth";

const Activate = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [steps, setSteps] = useState({
    step1: { current: true, visited: true },
    step2: { current: false, visited: false },
    step3: { current: false, visited: false },
  });

  const [kitData, setKitData] = useState({
    petId: "",
    code: 0,
    purchaseDetails: {
      online: { checked: false, reason: "" },
      vetClinics: { checked: false, reason: "" },
      petSupplyStores: { checked: false, reason: "" },
      petInsurance: { checked: false, reason: "" },
      petTeleVet: { checked: false, reason: "" },
    },
    careTeamIds: [],
  });

  let param = "activate";
  useEffect(() => {
    if (params.path === "code") {
      setSteps((prevSteps) => ({
        ...prevSteps,
        step1: { current: false, visited: true },
        step2: { current: false, visited: true },
        step3: { current: true, visited: true },
      }));
      setKitData({
        ...kitData,
        petId: location.state.petId,
        code: location.state.code,
      });
    }
  }, []);

  const changeStep = (selectedStepName: string) => {
    setSteps((prevSteps) => {
      const updatedSteps = { ...prevSteps };

      Object.keys(updatedSteps).forEach((step) => {
        updatedSteps[step as keyof typeof updatedSteps] = {
          ...updatedSteps[step as keyof typeof updatedSteps],
          current: step === selectedStepName,
          visited: updatedSteps[step as keyof typeof updatedSteps].visited || step === selectedStepName,
        };
      });
      return updatedSteps;
    });
  };

  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title="Activate">
        {steps.step1.current && (
          <div className="tw-w-9/10 tw-mx-auto  tw-font-bold tw-text-[1.25rem] lg:tw-text-[2.25rem]">Next Steps</div>
        )}
        {steps.step2.current && (
          <div className="tw-w-9/10 tw-mx-auto tw-py-6 lg:tw-py-12 tw-my-6 tw-bg-white tw-rounded-[0.625rem]">
            <p className="tw-pl-[1rem] lg:tw-pl-[2.3125rem] tw-text-[1.125rem] lg:tw-text-[1.625rem] tw-font-bold tw-leading-[1.9375rem]">
              What is the activation code on your box?
            </p>
          </div>
        )}
        {steps.step3.current && (
          <div className="tw-w-9/10 tw-mx-auto tw-py-6 lg:tw-py-12 tw-my-6 tw-bg-white tw-rounded-[0.625rem]">
            <p className="tw-pl-[1rem] lg:tw-pl-[2.3125rem] tw-text-[1.125rem] lg:tw-text-[1.625rem] tw-font-bold tw-leading-[1.9375rem]">
              Select or add a veterinarian you want to share the test result with. If you don’t have one, please click
              complete activation button below.
            </p>
            <p className="tw-pl-[1rem] tw-mt-5 lg:tw-pl-[2.3125rem] tw-text-[1.125rem] lg:tw-text-[1.625rem] tw-font-bold tw-leading-[1.9375rem]">
              *If you purchase a kit from a local hospital or a retailstore, please makes sure to input your vet and
              hospital information.
            </p>
          </div>
        )}
        {/* Middle main div */}
        <div className="tw-w-[95%] md:tw-w-9/10 tw-mx-auto tw-py-6 md:tw-py-12 tw-bg-white tw-rounded-[1.875rem]">
          {/* Middle inside div */}
          <div className="tw-w-[95%] md:tw-w-9/10 tw-mx-auto">
            {/* 1st row */}
            <div className="tw-flex tw-flex-col lg:tw-flex-row tw-gap-5 lg:tw-gap-0 lg:tw-items-center lg:tw-justify-between">
              <div className=" tw-flex tw-items-center tw-space-x-3 lg:tw-space-x-24">
                <div
                  className={`${
                    steps.step1.visited
                      ? ` tw-text-[0.7rem] lg:tw-text-2xl tw-font-bold`
                      : ` tw-cursor-pointer tw-text-[0.7rem]  lg:tw-text-xl tw-opacity-50`
                  } ${steps.step1.current ? "" : "tw-hidden"} md:tw-block sm:tw-text-[1rem]`}
                  // onClick={() => changeStep("step1")}
                >
                  1. Choose Pet
                  {steps.step1.current && <div className="tw-p-0.5 tw-bg-darkRed"></div>}
                </div>
                <div
                  className={`${
                    steps.step2.visited
                      ? ` tw-text-[0.7rem] lg:tw-text-2xl tw-font-bold`
                      : ` tw-cursor-pointer tw-text-[0.7rem]  lg:tw-text-xl tw-opacity-50`
                  } ${steps.step2.current ? "" : "tw-hidden"} md:tw-block sm:tw-text-[1rem]`}
                  // onClick={() => changeStep("step2")}
                >
                  2. Activate Kit
                  {steps.step2.current && <div className="tw-p-0.5 tw-bg-darkRed"></div>}
                </div>
                <div
                  className={`${
                    steps.step3.visited
                      ? ` tw-text-[0.7rem] lg:tw-text-2xl tw-font-bold`
                      : ` tw-cursor-pointer tw-text-[0.7rem]  lg:tw-text-xl tw-opacity-50`
                  } ${steps.step3.current ? "" : "tw-hidden"} md:tw-block sm:tw-text-[1rem]`}
                >
                  {steps.step3.current ? "3.  Select Vet Info" : "3.  Add Vet Info"}
                  {steps.step3.current && <div className="tw-p-0.5 tw-bg-darkRed"></div>}
                </div>
              </div>

              <div className="tw-hidden md:tw-flex md:tw-flex-1 tw-justify-end">
                {steps.step3.current && (
                  <button className="tw-ml-4 tw-w-fit tw-py-2 tw-px-3 lg:tw-px-3 tw-rounded-[0.625rem] tw-text-[0.875rem] lg:tw-text-[1.25rem] tw-font-bold tw-border-2 tw-border-solid tw-border-darkRed">
                    <span
                      onClick={() => {
                        navigate(`/user/care-team/add-care-team/add/${param}`, {
                          state: kitData,
                        });
                      }}
                    >
                      Add Vet Info
                    </span>
                  </button>
                )}
              </div>
            </div>
            {/* 2nd row */}
            <div className="tw-pt-5 md:tw-pt-14">
              {steps.step1.current && <StepOne changeStep={changeStep} setKitData={setKitData} kitData={kitData} />}
              {steps.step2.current && (
                <StepTwo
                  changeStep={changeStep}
                  setKitData={setKitData}
                  kitData={kitData}
                  purchaseDetails={kitData.purchaseDetails}
                />
              )}
              {steps.step3.current && <StepThree changeStep={changeStep} setKitData={setKitData} kitData={kitData} />}
            </div>
          </div>
        </div>
      </UserHeroSection>

      <footer className="tw-flex">
        <Footer />
      </footer>
    </UserAuth>
  );
};

export default Activate;
